import { Skeleton } from '@/components/ui';

/**
 * Loading placeholder for the event market page (ARC-82 §5) — mirrors the
 * loaded column: category eyebrow + title, the `h-[50px]` stat pill bar, the
 * 240px chart with its right-aligned timeframe tabs, the Yes/No buy pills,
 * and the accordion section rows. (A SPORTS event swaps to its own layout
 * only after data arrives, so this generic mirror stands in for both.)
 */
export function BinaryMarketPageSkeleton() {
  return (
    <div className="flex flex-col gap-5">
      {/* Header — eyebrow (icon + category), title, chance line. */}
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Skeleton className="size-8 shrink-0 rounded-full" />
          <Skeleton className="h-4 w-32 rounded" />
        </div>
        <Skeleton className="h-[26px] w-4/5 rounded" />
        <Skeleton className="h-4 w-24 rounded" />
      </div>

      {/* Volume / close-time stat bar. */}
      <Skeleton className="h-[50px] w-full rounded-[69px]" />

      {/* Price chart + timeframe tabs. */}
      <div className="flex flex-col gap-2">
        <Skeleton className="h-[240px] w-full rounded-card" />
        <Skeleton className="h-9 w-56 self-end rounded-pill" />
      </div>

      {/* Yes / No buy entries. */}
      <div className="flex gap-2">
        <Skeleton className="h-[42px] flex-1 rounded-[19px]" />
        <Skeleton className="h-[42px] flex-1 rounded-[19px]" />
      </div>

      {/* Accordion section rows (positions / order book / rules / comments). */}
      {[1, 2, 3, 4].map((i) => (
        <Skeleton key={i} className="h-[52px] w-full rounded-card" />
      ))}
    </div>
  );
}
